/** Render untrusted sheet names as text, with bounded table pagination. */
export function renderSheetSet(host, data) {
  host.replaceChildren();
  const element = (tag, text, parent = host) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    parent.append(node);
    return node;
  };
  element('h2', data.name || '未命名圖紙集');
  if (data.description) element('p', data.description);
  element('p', `共 ${data.sheets.length} 張圖紙 · ${data.subsets.length} 個子集`);
  element('p', '此處預覽圖紙集清冊；實際圖面保存在參照的 DWG，請從文件清單開啟對應檔案與版面。');
  if (data.subsets.length) element('p', `子集：${data.subsets.map(names => names.join(' / ')).join('、')}`);
  const label = element('label', '搜尋圖紙 ');
  const search = element('input', undefined, label);
  search.type = 'search';
  search.placeholder = '圖號、圖名、子集、DWG 或版面';
  const wrapper = element('div');
  wrapper.className = 'sheet-set-table-wrap';
  const table = element('table', undefined, wrapper);
  const heading = element('tr', undefined, element('thead', undefined, table));
  for (const title of ['順序', '子集', '圖號', '圖名', 'DWG 參照', 'Layout', '說明']) {
    element('th', title, heading).scope = 'col';
  }
  const body = element('tbody', undefined, table);
  const footer = element('div');
  footer.className = 'sheet-set-pagination';
  const previous = element('button', '上一頁', footer);
  const status = element('span', '', footer);
  status.setAttribute('role', 'status');
  const next = element('button', '下一頁', footer);
  previous.type = next.type = 'button';
  previous.className = next.className = 'btn btn-sm';
  let page = 0;
  const render = () => {
    const term = search.value.trim().toLocaleLowerCase();
    const rows = data.sheets.map((sheet, index) => ({sheet, index})).filter(({sheet}) =>
      [sheet.number, sheet.title, sheet.subset.join(' / '), sheet.drawing, sheet.layout, sheet.description]
        .some(value => String(value).toLocaleLowerCase().includes(term)));
    const pages = Math.max(1, Math.ceil(rows.length / 50));
    page = Math.min(page, pages - 1);
    body.replaceChildren();
    for (const {sheet, index} of rows.slice(page * 50, (page + 1) * 50)) {
      const row = element('tr', undefined, body);
      for (const value of [index + 1, sheet.subset.join(' / '), sheet.number, sheet.title,
        sheet.drawing, sheet.layout, sheet.description]) element('td', String(value || '—'), row);
    }
    if (!rows.length) element('td', data.sheets.length ? '沒有符合的圖紙' : '此圖紙集尚無圖紙', element('tr', undefined, body)).colSpan = 7;
    status.textContent = `${rows.length} 張 · 第 ${page + 1} / ${pages} 頁`;
    previous.disabled = page === 0;
    next.disabled = page >= pages - 1;
  };
  search.oninput = () => { page = 0; render(); };
  previous.onclick = () => { page--; render(); };
  next.onclick = () => { page++; render(); };
  render();
}
